import './index.scss';

import { Component, ReactNode, ContextType } from 'react';

import StepperContext from '../BraxStepper/context';

export type BraxStepProps = {
    id: string,
    title: ReactNode,
    enable: boolean,
    children: ReactNode
};

export class BraxStep extends Component<BraxStepProps> {

    static contextType = StepperContext;

    declare context: ContextType<typeof StepperContext>

    componentDidMount() {
        this.context.add({ ...this.props });
    }

    componentDidUpdate(prevProps: BraxStepProps) {
        if (prevProps.enable !== this.props.enable)
            this.context.setEnable(this.props.id, this.props.enable);

        if (prevProps.title !== this.props.title)
            this.context.setTitle(this.props.id, this.props.title);
    }

    componentWillUnmount() {
        this.context.remove(this.props.id);
    }

    render() {
        return (
            <div className={`brax-step ${this.context.active !== this.props.id ? 'brax-step-hidden' : ''}`}>
                { this.props.children }
            </div>
        );
    }

}
